export default __webpack_public_path__ + "static/media/avatar.a8d55f5d.svg";